import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import ModalTitle, { withModalSx, modalCancelButtonSx } from "server/components/Modals/ModalTitle";
import { settings } from "app";

const ImportErrorsDialog = props => {
  const { errors, open, onClose } = props;

  return (
    <Dialog
      open={open && errors}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={withModalSx()}
    >
      <ModalTitle title="⚠️ Грешки при качване на оценки" />
      <DialogContent dividers>
        <TableContainer
          component={Paper}
          sx={{ boxShadow: 3, maxHeight: 400, overflowY: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: theme => theme.palette.secondary.main }}>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Ред</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Входящ номер</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>Съобщение</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {errors.map((error, index) => (
                <TableRow key={index}>
                  <TableCell>{error.rowNumber}</TableCell>
                  <TableCell>{error.candidateHashNumber}</TableCell>
                  <TableCell sx={{ color: theme => theme.palette.error.main, fontWeight: "bold" }}>
                    {error.message}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          {...(settings.style.modernUi
            ? { variant: "outlined", color: "error", sx: modalCancelButtonSx }
            : {
                variant: "contained",
                sx: {
                  bgcolor: theme => theme.palette.primary.main,
                  color: "#fff",
                  "&:hover": { bgcolor: "#5a1fb0" },
                },
              })}
        >
          Затвори
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportErrorsDialog;
